import { RootState } from 'store';
import IMotiveException from 'types/company/payroll/IMotiveException';

export const motiveExceptionsSelector = (state: RootState): IMotiveException[] =>
  state.motiveExceptions.motiveExceptions;

export const motiveExceptionsLoadingSelector = (state: RootState): boolean => state.motiveExceptions.loading;
export const motiveExceptionsGetErrorSelector = (state: RootState): boolean => state.motiveExceptions.getError;

export const addMotiveExceptionSuccessSelector = (state: RootState): boolean => state.motiveExceptions.addSuccess;
export const addMotiveExceptionErrorSelector = (state: RootState): string => state.motiveExceptions.addError;

export const updateMotiveExceptionSuccessSelector = (state: RootState): boolean => state.motiveExceptions.updateSuccess;
export const updateMotiveExceptionErrorSelector = (state: RootState): string => state.motiveExceptions.updateError;

export const deleteMotiveExceptionSuccessSelector = (state: RootState): boolean => state.motiveExceptions.deleteSuccess;
export const deleteMotiveExceptionErrorSelector = (state: RootState): string => state.motiveExceptions.deleteError;
